import ApiV1 from "@/configs/axios/ApiV1";
import { HasPermissionOrThrow } from "@/utils/permisshoinHelper";
import { fakeResponse } from "@/services/fake";
import PermissionsV1 from "@/router/permissions/v1";

export function langGetTranslatesByKey(key) {
  return ApiV1.get(`lang/translates?lang=${key}`);
}

export function langGetTranslates(params) {
  HasPermissionOrThrow(PermissionsV1["LANG.GET_LIST"]);
  return ApiV1.get("lang/languages", { params });
}

export function langCreateTranslate(payload) {
  HasPermissionOrThrow(PermissionsV1["LANG.CREATE"]);
  return ApiV1.post("lang/languages", payload);
}

export function langUpdateTranslate(id, payload) {
  HasPermissionOrThrow(PermissionsV1["LANG.UPDATE"]);
  return ApiV1.put(`lang/languages/${id}`, payload);
}
